/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './UsersRpc';
import * as Queries from './UsersRpc.dfc.new';
import type { AdditionalContextArgs } from './UsersRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetUserIdsOnHubByRoleIdAndPendingStatusQueryReturn<T extends boolean> =
  Omit<
    QueryResult<
      Record<
        'result',
        References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType
      >,
      References.GetUserIdsOnHubByRoleIdAndPendingStatusRequestType
    >,
    'data'
  > & {
    data:
      | (T extends true
          ? Record<
              'getUserIdsOnHubByRoleIdAndPendingStatus',
              References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType
            >
          : References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType)
      | undefined;
  };

export function useGetUserIdsOnHubByRoleIdAndPendingStatusQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<
      'result',
      References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType
    >,
    References.GetUserIdsOnHubByRoleIdAndPendingStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserIdsOnHubByRoleIdAndPendingStatusQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_USER_IDS_ON_HUB_BY_ROLE_ID_AND_PENDING_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserIdsOnHubByRoleIdAndPendingStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserIdsOnHubByRoleIdAndPendingStatusQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetUserIdsOnHubByRoleIdAndPendingStatusQueryReturn<T>;
}

type UseGetUserIdsOnHubByRoleIdAndPendingStatusLazyQueryReturn<
  T extends boolean,
> = LazyQueryResultTupleOverride<
  Record<
    'result',
    References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType
  >,
  References.GetUserIdsOnHubByRoleIdAndPendingStatusRequestType,
  T extends true
    ? Record<
        'getUserIdsOnHubByRoleIdAndPendingStatus',
        References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType
      >
    : References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType
>;

export function useGetUserIdsOnHubByRoleIdAndPendingStatusLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<
      'result',
      References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType
    >,
    References.GetUserIdsOnHubByRoleIdAndPendingStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserIdsOnHubByRoleIdAndPendingStatusLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_USER_IDS_ON_HUB_BY_ROLE_ID_AND_PENDING_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserIdsOnHubByRoleIdAndPendingStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetUserIdsOnHubByRoleIdAndPendingStatusLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetUserIdsOnHubByRoleIdAndPendingStatusLazyQueryReturn<T>;
}

type UseGetUserIdsOnHubByRoleIdAndPendingStatusSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<
      'result',
      References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType
    >,
    References.GetUserIdsOnHubByRoleIdAndPendingStatusRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getUserIdsOnHubByRoleIdAndPendingStatus',
        References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType
      >
    : References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType;
};

export function useGetUserIdsOnHubByRoleIdAndPendingStatusSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<
      'result',
      References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType
    >,
    References.GetUserIdsOnHubByRoleIdAndPendingStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserIdsOnHubByRoleIdAndPendingStatusSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_USER_IDS_ON_HUB_BY_ROLE_ID_AND_PENDING_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getUserIdsOnHubByRoleIdAndPendingStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserIdsOnHubByRoleIdAndPendingStatusSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetUserIdsOnHubByRoleIdAndPendingStatusSuspenseQueryReturn<T>;
}

type UseFilterOutInvisibleUsersQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.FilterOutInvisibleUsersResponseType>,
    References.FilterOutInvisibleUsersRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'filterOutInvisibleUsers',
            References.FilterOutInvisibleUsersResponseType
          >
        : References.FilterOutInvisibleUsersResponseType)
    | undefined;
};

export function useFilterOutInvisibleUsersQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FilterOutInvisibleUsersResponseType>,
    References.FilterOutInvisibleUsersRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFilterOutInvisibleUsersQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.FILTER_OUT_INVISIBLE_USERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            filterOutInvisibleUsers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFilterOutInvisibleUsersQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFilterOutInvisibleUsersQueryReturn<T>;
}

type UseFilterOutInvisibleUsersLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FilterOutInvisibleUsersResponseType>,
    References.FilterOutInvisibleUsersRequestType,
    T extends true
      ? Record<
          'filterOutInvisibleUsers',
          References.FilterOutInvisibleUsersResponseType
        >
      : References.FilterOutInvisibleUsersResponseType
  >;

export function useFilterOutInvisibleUsersLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FilterOutInvisibleUsersResponseType>,
    References.FilterOutInvisibleUsersRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFilterOutInvisibleUsersLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FILTER_OUT_INVISIBLE_USERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            filterOutInvisibleUsers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFilterOutInvisibleUsersLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFilterOutInvisibleUsersLazyQueryReturn<T>;
}

type UseFilterOutInvisibleUsersSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FilterOutInvisibleUsersResponseType>,
    References.FilterOutInvisibleUsersRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'filterOutInvisibleUsers',
        References.FilterOutInvisibleUsersResponseType
      >
    : References.FilterOutInvisibleUsersResponseType;
};

export function useFilterOutInvisibleUsersSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FilterOutInvisibleUsersResponseType>,
    References.FilterOutInvisibleUsersRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFilterOutInvisibleUsersSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FILTER_OUT_INVISIBLE_USERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            filterOutInvisibleUsers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFilterOutInvisibleUsersSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFilterOutInvisibleUsersSuspenseQueryReturn<T>;
}

type UseGetUsersByIdsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetUsersByIdsResponseType>,
    References.GetUsersByIdsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getUsersByIds', References.GetUsersByIdsResponseType>
        : References.GetUsersByIdsResponseType)
    | undefined;
};

export function useGetUsersByIdsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetUsersByIdsResponseType>,
    References.GetUsersByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUsersByIdsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_USERS_BY_IDS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUsersByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUsersByIdsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetUsersByIdsQueryReturn<T>;
}

type UseGetUsersByIdsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetUsersByIdsResponseType>,
    References.GetUsersByIdsRequestType,
    T extends true
      ? Record<'getUsersByIds', References.GetUsersByIdsResponseType>
      : References.GetUsersByIdsResponseType
  >;

export function useGetUsersByIdsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetUsersByIdsResponseType>,
    References.GetUsersByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUsersByIdsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_USERS_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUsersByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetUsersByIdsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetUsersByIdsLazyQueryReturn<T>;
}

type UseGetUsersByIdsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetUsersByIdsResponseType>,
    References.GetUsersByIdsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getUsersByIds', References.GetUsersByIdsResponseType>
    : References.GetUsersByIdsResponseType;
};

export function useGetUsersByIdsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetUsersByIdsResponseType>,
    References.GetUsersByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUsersByIdsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_USERS_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getUsersByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUsersByIdsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetUsersByIdsSuspenseQueryReturn<T>;
}

type UseSetUserPermissionsMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SetUserPermissionsResponseType>,
    References.SetUserPermissionsRequestType,
    T extends true
      ? Record<'setUserPermissions', References.SetUserPermissionsResponseType>
      : References.SetUserPermissionsResponseType
  >;

export function useSetUserPermissionsMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SetUserPermissionsResponseType>,
    References.SetUserPermissionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSetUserPermissionsMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SET_USER_PERMISSIONS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            setUserPermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSetUserPermissionsMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSetUserPermissionsMutationReturn<T>;
}

type UseSetUserPermissionsAndSeatsMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SetUserPermissionsAndSeatsResponseType>,
    References.SetUserPermissionsAndSeatsRequestType,
    T extends true
      ? Record<
          'setUserPermissionsAndSeats',
          References.SetUserPermissionsAndSeatsResponseType
        >
      : References.SetUserPermissionsAndSeatsResponseType
  >;

export function useSetUserPermissionsAndSeatsMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.SetUserPermissionsAndSeatsResponseType>,
    References.SetUserPermissionsAndSeatsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSetUserPermissionsAndSeatsMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SET_USER_PERMISSIONS_AND_SEATS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            setUserPermissionsAndSeats: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSetUserPermissionsAndSeatsMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSetUserPermissionsAndSeatsMutationReturn<T>;
}

type UseAddUserBulkMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.AddUserBulkResponseType>,
  References.AddUserBulkRequestType,
  T extends true
    ? Record<'addUserBulk', References.AddUserBulkResponseType>
    : References.AddUserBulkResponseType
>;

export function useAddUserBulkMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.AddUserBulkResponseType>,
    References.AddUserBulkRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAddUserBulkMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.ADD_USER_BULK_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            addUserBulk: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseAddUserBulkMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseAddUserBulkMutationReturn<T>;
}
